__webpack_require__.p = "//assets.pipelinecrm.com/298b5e7e72b6fb6eb37b4af70955e31d942270ca/webpack/";